import { render, staticRenderFns } from "./NbnBulkUpload.vue?vue&type=template&id=5cde0d5a"
import script from "./NbnBulkUpload.vue?vue&type=script&lang=js"
export * from "./NbnBulkUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports